import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import { __assign } from "tslib";
import { cloneRequest } from "./cloneRequest";
/**
 * @internal
 */

export function moveHeadersToQuery(request) {
  var _a = typeof request.clone === "function" ? request.clone() : cloneRequest(request),
      headers = _a.headers,
      _b = _a.query,
      query = _b === void 0 ? {} : _b;

  for (var _i = 0, _c = Object.keys(headers); _i < _c.length; _i++) {
    var name = _c[_i];
    var lname = name.toLowerCase();

    if (lname.substr(0, 6) === "x-amz-") {
      query[name] = headers[name];
      delete headers[name];
    }
  }

  return __assign(__assign({}, request), {
    headers: headers,
    query: query
  });
}